import { object, string } from 'yup';
//import { emailRegexp } from '@/configs/regexp';

export const createApplicationSchema = (t) => {
  return object({
    name: string()
      .max(100, t('form.length_less_100'))
      .required(t('form.required')),
    phone: string().max(17, t('form.phone')).required(t('form.required')),
    question: string().max(2500, t('form.length_less_2500')),
  });
};

export const createConsultationWideSchema = (t) => {
  return object({
    name: string()
      .max(100, t('form.length_less_100'))
      .required(t('form.required')),
    phone: string().max(17, t('form.phone')).required(t('form.required')),
    question: string().max(2500, t('form.length_less_2500')),
  });
};
export const createVacancySchema = (t) => {
  return object({
    name: string()
      .max(100, t('form.length_less_100'))
      .required(t('form.required')),
    phone: string().max(17, t('form.phone')).required(t('form.required')),
    question: string().max(2500, t('form.length_less_2500')),
  });
};
export const createConsultationSchema = (t) => {
  return object({
    phone: string().max(17, t('form.phone')).required(t('form.required')),
  });
};
export const createSubscriptionSchema = (t) => {
  return object({
    email: string()
      .min(1, { message: t('form.required') })
      .email({ message: t('form.email') }),
  });
};

export const createSearchSchema = (t) => {
  return object({
    s: string().min(3, t('form.length_more_3')).required(t('form.required')),
  });
};
